import React from "react";
import Logo from '@/assets/images/logo.svg';

function redirectOrigin(isStatic) {
  if (isStatic) {
    return
  }
  window.location.replace(window.location.origin)
}

const Footer = ({ message = {}, children }) => (
  <footer className="footer">
    <div className="container">
      <div className="row">
        <div className={`left col-md-${12 - message.links.length * 2}`}>
        {
          !message.hideLogo
          ? <a className="logo-group" onClick={() => redirectOrigin(message.logoStatic)}>
            <img className="logo" src={Logo} alt="Shopee Logo" />
          </a>
          : null
        }
          <p className="text">{message.follow}</p>
          <div className="social">
          {
            (message.social || []).map(item => (
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                key={item.name}
              >
                <img
                  src={item.icon}
                  className="icon"
                  alt={item.name}
                ></img>
              </a>
            ))
          }
          </div>
        </div>
        {
          (message.links || []).map((links, index) => {
            const isShowLinkGroupTitle = !!message.linkGroupDesc;
            const linkDesc = isShowLinkGroupTitle  ? message.linkGroupDesc[index] : '';
            return (
              <div className="col-md-2 links" key={index}>
              { isShowLinkGroupTitle ? <p className="link-group-desc">{linkDesc}</p>  : null }
              {
                links.map(link => (
                  <a 
                    className="footer-link" 
                    href={link.href}
                    target={link.target ? link.target : '_self'}
                    rel={link.target ? 'noopener noreferrer' : ''}
                    key={link.text}
                  >
                    {link.text}
                  </a>
                ))
              }
            </div>
            )
          }
          )
        }
      </div>
      <div className="copyright">
        {
          children
          ? children
          : <p>
            {message.copyright}
            <span className="policy-container">
              {
                message.tc ? <span className="tc"><a href={message.tc} target="_blank" rel="noopener noreferrer">Terms of Service </a></span> : null
              }
              {
                message.privacyPolicy ? <span className="pp">| <a href={message.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy Policy</a></span> : null
              }
            </span>
          </p>
        }
      </div>
    </div>
  </footer>
);

export default Footer;
